<template>
    <div class="poster_optimize_box" id="poster_optimize_box">
        <div class="content">
            <img class="top_img" :src="getFilePath(coverImage)" />
            <div class="user-icon-name">
                <div class="user-icon"><img :src="headimgurl" class="userImg" /></div> 
                <div class="user_name">{{ name }}</div>
            </div>
            <div class="product-name">{{ productName.length>34 ? productName.substr(0, 34) + '...': productName }}</div>
            <div class="share-code-price">
                <div class="left">
                    <div class="price">&yen;{{price}}<span class="low-text">&nbsp;起</span></div>     
                    <div class="tips">
                        <span class="hot">热卖中</span>
                        <span class="code-text">长按识别 →</span>
                    </div>
            </div>  
            <canvas class="qrcode" id="qrcode"></canvas>  
            </div>
        </div>
        <div class="share-footer">
            <div class="footer-item"><img src="@/assets/productShare/right-icon.png" /><span>阳光行程</span></div>
            <div class="footer-item"><img src="@/assets/productShare/right-icon.png" /><span>阳光价格</span></div>
            <div class="footer-item"><img src="@/assets/productShare/right-icon.png" /><span>阳光服务</span></div>
        </div>
    </div>
</template>
<script>
import QRCode from "qrcode";
import html2canvas from '../../utils/html2canvas'
// import html2canvas from "html2canvas";
import { getImgUrl } from '../../mixins/getImgUrl'
import { Toast } from 'vant'
import qs from 'qs'

export default {
    name: 'product-poster-optimize',
	props: ['coverImage', 'productName', 'des', 'price', 'sharePayFlag','minprice'],
	mixins: [getImgUrl],
	data() {
		return {
			headimgurl: '',
			name: '',
			phone: '',
		}
	},
    created() {
        const wechatUser = JSON.parse(localStorage.getItem('wechatUser')) || {}
		this.headimgurl = wechatUser.headimgurl
		const user = this.$store.state.userInfo_v2?.user
        const flag = localStorage.getItem('flag')
		if (user && flag === 'false') {
			// this.name = user.userName
            this.name = wechatUser.nickname
			this.phone = user.mobile
		} else {
			this.name = wechatUser.nickname
		}
    },
    mounted() {
        Toast.loading({
            duration: 0,
            forbidClick: true,
            message: "加载中...",
        });
        this.addAplusQueue();
    },
    methods: {
        addAplusQueue(){
            //query信息来源于浏览器url后面查询信息，例如：http://www.test.com?a=1&b=2&c=3
            //这里query就是{a:1, b:2, c:3}这样的字典，由开发者自行解析
            const { tc } = this.$route.query;
            const openid = localStorage.getItem("openId");
            const { appKey } = this.$configs.constants.UMENG;
            let data = {
                appkey: appKey,
                openid, 
                unionId: '',
                trackCode: tc || '',
                rootTrackCode: '',
                url: location.href
            };
            const that = this;
            aplus.getNextTrackCode(data, function(data){
                const { trackCode } = data;
                console.log('NextTrackCode:', trackCode);
                that.toCanvas(trackCode);
            });
        },
        toCanvas(trackCode){
            this.$nextTick(() => {
                var url = window.location.href
                let shareUrl = qs.parse(url.split('?')[1])
                delete shareUrl.shareFlag
                //+
                if (this.sharePayFlag) {
                    shareUrl.shareFlag = 1
                }
                var userInfo_v2 = JSON.parse(localStorage.userInfo_v2)
                const query = { trackCode }
                aplus.trackShare(query, function(res){
                    console.log('分享回调', res);
                });
                // userName分享人名称
                const { userId='', userName='' } = userInfo_v2.user;
                url = `${url.split('?')[0]}?${qs.stringify(shareUrl)}&sharedUserId=${userId}&tcName=${userName}&tc=${trackCode}`
                console.log('分享url', url)
                let canvas = document.getElementById('qrcode');

                QRCode.toCanvas(canvas, url, (error) => {
                    if (error){
                        console.log(error)
                    } else {
                        canvas.style.width = 130 * (document.documentElement.clientWidth / 750) + 'px';
                        canvas.style.height = 130 * (document.documentElement.clientWidth / 750) + 'px';
                        setTimeout(async () => {
                            //let shareCard = document.getElementById('poster_box')
                            let shareCard = document.getElementById("poster_optimize_box");
                            (window.html2canvas || html2canvas)(shareCard, {
                                allowTaint: true,
                                useCORS: true,
                                scrollX: 0,
                                scrollY: 0,
                                width: shareCard.clientWidth,
                                height: shareCard.clientHeight
                            }).then((canvas) => {
                                const width = 650 * (document.documentElement.clientWidth / 750);
                                const height = 947 * (document.documentElement.clientWidth / 750);
                                const tempImg = document.createElement('img');
                                tempImg.src = canvas.toDataURL();
                                tempImg.width  = width;
                                // tempImg.height = height;
                                tempImg.alt = "分享海报";
                                tempImg.style.borderRadius = '12px';
                                // tempImg.style.marginTop = 25 * (document.documentElement.clientWidth / 750) + 'px';
                                document.getElementById("poster_optimize_box").innerHTML = '';
                                document.getElementById("poster_optimize_box").appendChild(tempImg);
                                Toast.clear()
                            })
                        }, 0)
                    }
                })
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.poster_optimize_box {
    position: relative;
    background: #3377FF;
    border-radius: vw(18);
    width: 100%;
    padding-top: vw(12);

    .content {
        width: vw(600);
        height: vw(858);
        background: #fff;
        border-radius: vw(12);
        margin-left: vw(25);
        .top_img {
            width: vw(600);
            height: vw(530);
            object-fit: cover;
        }
        .user-icon-name {
            display: flex;
            align-items: center;
            .user-icon {
                margin-top: vw(-50);
                background: #fff;
                border-radius: 50%;
                padding: vw(10);
                position: absolute;
                margin-left: vw(20);
                .userImg {
                    width: vw(100);
                    height: vw(100);
                    border-radius: 50%;
                }
            }
            .user_name {
                font-size: vw(26);
                color: #8592A6;
                margin-left: vw(148);
                margin-top: vw(12);
            }
        }
        .product-name {
            color: #333;
            font-size: vw(28);
            margin-left: vw(30);
            margin-top: vw(20);
            font-weight: 700;
        }
        .share-code-price {
            display: flex;
            justify-content: space-between;
            margin: vw(15) vw(30) 0 vw(30);
            .left {
                .price {
                    color: #FF3333;
                    font-size: vw(48);
                    font-weight: 700;
                    .low-text {
                        font-size: vw(24);
                    }
                }
                .tips {
                border: 1px solid #3377FF;
                width: vw(260);
                font-size: vw(24);
                border-radius: vw(23);
                margin-top: vw(20);
                .hot {
                    display: inline-block;
                    background: #3377FF; 
                    border-radius: vw(23);
                    height: vw(40);
                    color: #fff;
                    width: vw(108);
                    text-align: center;
                    line-height: vw(40);
                }
                .code-text {
                    color: #3377FF;
                    margin-left: vw(10);
                }
            }
            }
        }
    }
    .share-footer {
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: vw(20) 0;
        .footer-item {
            display: flex;
            align-items: center;
            img {
                width: vw(22);
                height: vw(22);
            }
            span {
                font-size: vw(26);
                color: #FFFFFF;
                margin-left: vw(8);
            }
        }
        
    }
}
</style>